<template>
  <div class="card-title-container">
    <p v-if="parentKeys.length" class="cl-card-parent-title">
      <span v-for="(key, index) in parentKeys" :key="`${key}-${index}`">
        {{ $t(key) }}
        <span v-if="index < parentKeys.length - 1"> / </span>
      </span>
      <span> / </span>
    </p>
    <p class="cl-card-title">
      {{ $t(currentKey) }}
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import { useRoute } from 'vue-router';

export default defineComponent({
  name: 'CardTitleComponent',
  setup() {
    const route = useRoute();

    const segments = computed<string[]>(() => {
      const meta = route.meta as {
        titleTrail?: string[];
        parentKey?: string;
        titleKey?: string;
      };

      if (Array.isArray(meta.titleTrail) && meta.titleTrail.length > 0) {
        return meta.titleTrail;
      }

      const keys: string[] = [];
      if (meta.parentKey) keys.push(meta.parentKey);
      if (meta.titleKey) keys.push(meta.titleKey);

      if (keys.length > 0) {
        return keys;
      }

      const name = route.name as string | undefined;
      if (name) {
        return [name];
      }

      return ['home'];
    });

    const parentKeys = computed(() => segments.value.slice(0, -1));
    const currentKey = computed(() => segments.value[segments.value.length - 1] ?? 'home');

    return {
      parentKeys,
      currentKey,
    };
  },
});
</script>

